var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 127,
    viewBox: "0 0 170 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 94,
    rx: 85,
    ry: 33,
    fill: "url(#0f81ww04ga)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.862,
    cy: 61.102,
    rx: 24.88,
    ry: 6.275,
    transform: "rotate(110 93.862 61.102)",
    fill: "url(#5qvwjcwvtb)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.631,
    cy: 61.746,
    rx: 24.88,
    ry: 6.275,
    transform: "rotate(110 95.63 61.746)",
    fill: "url(#j5poaultrc)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.818,
    cy: 62.15,
    rx: 23.935,
    ry: 5.333,
    transform: "rotate(110 95.818 62.15)",
    fill: "url(#5ru5icrrdd)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.435,
    cy: 62.475,
    rx: 21.416,
    ry: 5.333,
    transform: "rotate(110 96.435 62.475)",
    fill: "url(#j9ut25w2be)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.24 43.765c.28.102.521.297.722.576l41.948 33.432a3.19 3.19 0 0 1-2.13 5.682l-53.252-2.362a1.52 1.52 0 0 1-.86-.039c-2.635-.959-1.733-10.084 2.015-20.38 3.747-10.298 8.922-17.868 11.557-16.909z",
    fill: "url(#pqenkn8tsf)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "emiv3qiaig",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 43,
    width: 60,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.24 43.765c.28.102.521.297.722.576l41.948 33.432a3.19 3.19 0 0 1-2.13 5.682l-53.252-2.362a1.52 1.52 0 0 1-.86-.039c-2.635-.959-1.733-10.084 2.015-20.38 3.747-10.298 8.922-17.868 11.557-16.909z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emiv3qiaig)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.152 63.574s-6.067 9.675-7.921 14.77c-1.854 5.094-3.203 15.794-3.203 15.794l-7.243-2.636A59.919 59.919 0 0 1 141.899 61.7l.438-.606 6.815 2.48z",
    fill: "url(#ko8z5g4a2h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.276 47.463-4.519 6.564a63.002 63.002 0 0 0-10.61 27.802l-.969 7.64-11.117-4.046s.535-12.344 4.293-22.668 12.125-19.222 12.125-19.222l10.797 3.93z",
    fill: "url(#87w59l2fei)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.332 58.543-.389.473a47.25 47.25 0 0 0-10.736 30.092l-8.885-3.234s1.415-10.398 3.358-15.738c1.944-5.34 7.767-14.827 7.767-14.827l8.885 3.234z",
    fill: "url(#uz7zn5jz2j)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.544 81.46a1.193 1.193 0 0 0-.693-1.523L96.234 61.631l-1.35 2.733a23.513 23.513 0 0 0-2.146 14.093l50.595 3.784c.534.04 1.028-.28 1.211-.782z",
    fill: "url(#z4q0i7mtik)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.147 74.274a.855.855 0 0 1-1.143.492l-33.883-14.628-.026-.306a8.067 8.067 0 0 1 6.14-8.522l28.629 21.993c.296.228.41.62.283.97z",
    fill: "url(#p0q2bvhnul)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m87.266 85.083-1.988-.724",
    stroke: "url(#0t7pd3lb6m)",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.533 84.76s-.474-.51-.575-.77c-.102-.26-.282-.772-.282-.772l-1.075-.35.8 1.48 1.132.412z",
    fill: "url(#6zv3nt1onn)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.214 38.393s-1.462-.563-1.898-.69c-.399-.117-.653-.083-.705-.078-.087.008-.552.085-.786.227-.375.227-1.385 1.196-1.385 1.196l3.115-.206 1.659-.449z",
    fill: "url(#4bb290izco)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5,
    cy: 92,
    rx: 39.5,
    ry: 10,
    fill: "url(#2aq0kffcwp)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5,
    cy: 89,
    rx: 39.5,
    ry: 10,
    fill: "url(#iieq0p219q)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86,
    cy: 88.5,
    rx: 38,
    ry: 8.5,
    fill: "url(#248gra0j4r)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.15,
    cy: 87.399,
    rx: 34,
    ry: 8.5,
    fill: "url(#aedlzr9sms)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 85.908c0-.476.16-.942.467-1.395L81.57 3.455a5.059 5.059 0 0 1 9.625.091L116.59 84.6c.27.426.41.863.41 1.31C117 90.376 102.897 94 85.5 94S54 90.377 54 85.908z",
    fill: "url(#92bt7hr7tt)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ia05qaky6u",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 0,
    width: 63,
    height: 94
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 85.908c0-.476.16-.942.467-1.395L81.57 3.455a5.059 5.059 0 0 1 9.625.091L116.59 84.6c.27.426.41.863.41 1.31C117 90.376 102.897 94 85.5 94S54 90.377 54 85.908z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ia05qaky6u)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.164 7.848S76.894 11.66 85.5 11.66c8.607 0 25.303-3.812 25.303-3.812V20.13a94.776 94.776 0 0 1-50.496-.398l-1.143-.326V7.847z",
    fill: "url(#yvbqdyz80v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.723 56.88 12.166 3.17a99.998 99.998 0 0 0 47.401.737l11.841-2.695v18.856s-18.705 5.926-36.147 5.926c-17.443 0-35.26-7.682-35.26-7.682V56.88z",
    fill: "url(#ah2t8dz9hw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.164 31.288.916.323a74.748 74.748 0 0 0 50.723-.323v15.07S94.522 49.906 85.5 49.906c-9.022 0-26.336-3.55-26.336-3.55v-15.07z",
    fill: "url(#np32lfrfnx)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.349 5a1.894 1.894 0 0 0-1.894 1.86L85 88.158l4.8.533a37.23 37.23 0 0 0 22.2-4.468L90.172 6.383A1.894 1.894 0 0 0 88.35 5z",
    fill: "url(#8ui7c9k9fy)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.561 17c.781 0 1.4.657 1.355 1.436l-3.425 58.725-.423.197A12.8 12.8 0 0 1 62 72.816L79.267 17.95c.178-.566.702-.95 1.294-.95z",
    fill: "url(#b7h758055z)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.857 88.807v3.371",
    stroke: "url(#8pafsz0kuA)",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.774 90.08s-.505.988-.838 1.282c-.333.294-.998.842-.998.842l.061 1.802L124.774 92v-1.92z",
    fill: "url(#w7acoixgqB)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 88.875s-.046 2.497 0 3.219c.042.661.231 1.022.267 1.099.059.124.426.78.765 1.053.543.436 2.537 1.421 2.537 1.421l-2-4.552-1.57-2.24z",
    fill: "url(#ec0o0yfa5C)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0f81ww04ga",
    x1: -95.188,
    y1: 90.949,
    x2: -57.463,
    y2: 198.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF9E7",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF0CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5qvwjcwvtb",
    x1: 52.9,
    y1: 66.001,
    x2: 76.663,
    y2: 97.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E98B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j5poaultrc",
    x1: 53.241,
    y1: 62.928,
    x2: 61.708,
    y2: 86.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6099B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5ru5icrrdd",
    x1: 10.875,
    y1: 41.517,
    x2: 12.954,
    y2: 73.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j9ut25w2be",
    x1: 55.419,
    y1: 64.973,
    x2: 68.556,
    y2: 90.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1CADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0C9DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pqenkn8tsf",
    x1: 97.449,
    y1: 116.079,
    x2: 148.536,
    y2: 73.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3E5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA1BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ko8z5g4a2h",
    x1: 144.58,
    y1: 80.865,
    x2: 132.34,
    y2: 65.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "87w59l2fei",
    x1: 125.202,
    y1: 64.725,
    x2: 102.806,
    y2: 48.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uz7zn5jz2j",
    x1: 137.392,
    y1: 71.006,
    x2: 121.312,
    y2: 59.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.917
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z4q0i7mtik",
    x1: 145.266,
    y1: 79.477,
    x2: 95.149,
    y2: 61.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p0q2bvhnul",
    x1: 138.837,
    y1: 75.126,
    x2: 100.512,
    y2: 61.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0t7pd3lb6m",
    x1: 87.372,
    y1: 84.792,
    x2: 85.419,
    y2: 84.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6zv3nt1onn",
    x1: 86.928,
    y1: 83.674,
    x2: 84.614,
    y2: 82.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CADC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4bb290izco",
    x1: 102.407,
    y1: 36.543,
    x2: 99.515,
    y2: 39.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#649DBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#649CB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2aq0kffcwp",
    x1: 20.469,
    y1: 99.807,
    x2: 58.381,
    y2: 149.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E98B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iieq0p219q",
    x1: 18.201,
    y1: 90.884,
    x2: 31.736,
    y2: 128.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6099B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "248gra0j4r",
    x1: -48.856,
    y1: 55.617,
    x2: -45.529,
    y2: 106.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aedlzr9sms",
    x1: 21.032,
    y1: 91.38,
    x2: 42.016,
    y2: 132.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1CADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0C9DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "92bt7hr7tt",
    x1: 165.569,
    y1: 56.66,
    x2: 74.17,
    y2: 3.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3E5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C89AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yvbqdyz80v",
    x1: 87.444,
    y1: 5.27,
    x2: 71.577,
    y2: 31.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah2t8dz9hw",
    x1: 73.887,
    y1: 43.089,
    x2: 62.292,
    y2: 85.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np32lfrfnx",
    x1: 76.638,
    y1: 21.408,
    x2: 68.4,
    y2: 51.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.917
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8ui7c9k9fy",
    x1: 77.073,
    y1: 19.003,
    x2: 118.27,
    y2: 49.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7h758055z",
    x1: 82,
    y1: 17,
    x2: 82,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8pafsz0kuA",
    x1: 124.366,
    y1: 88.807,
    x2: 124.366,
    y2: 92.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w7acoixgqB",
    x1: 122.938,
    y1: 90.081,
    x2: 122.938,
    y2: 94.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CADC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec0o0yfa5C",
    x1: 44.221,
    y1: 92.59,
    x2: 49.764,
    y2: 95.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#649DBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#649CB9"
  })))));
};
export default SvgError;